import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCalendarTodaySvg } from "./IconCalendarTodaySvg.mjs";
const IconCalendarToday = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCalendarTodaySvg, ...iconProps });
};
export {
  IconCalendarToday
};
